module.exports = __webpack_public_path__ + "static/media/cross-check.dca0582e.png";